var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"profile-info"}},[_c('b-row',[_c('b-col',{attrs:{"lg":"9","cols":"12"}},[_c('b-card',[_c('router-view',{key:_vm.$route.path})],1)],1),_c('b-col',{attrs:{"lg":"3","cols":"12"}},[_c('instructions-card')],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }